module.exports = __webpack_public_path__ + "static/media/OilGasNew.52dafab0.svg";